import MuiBox from "@mui/material/Box"
import WalletButton, { WalletButtonProps } from "@stakefish/ui/components/WalletButton"

export const DisabledWalletButton = ({ wallet }: Pick<WalletButtonProps, "wallet">) => (
  <MuiBox mb={2}>
    <WalletButton wallet={wallet} onWalletButtonClick={null} disabled />
  </MuiBox>
)
